import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";


class BaseContent extends NousCoreModel {
	authorName = "";
	contentCustomTags = {};
	copyright = "";
	extraData = {
		needReview: false,
	};
	referenceVolumes = [];
	referenceVolumeGuids = [];
	relatedContents = [];
	relatedLinks = [];
	tags = [];
	title = "";
	type = "";

	__pageTagsLabel = "";
	__referenceVolumeLabel = "";
	__relatedImagesCount = 0;
	__relatedPlacesCount = 0;
	__relatedTextsCount = 0;
	__tags = "";
	__type_image = false;
	__type_place = false;
	__type_text = false;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		exportData.extraData = this.exportObjectField("extraData");
		exportData.relatedContents = this.exportArrayField("relatedContents");
		exportData.referenceVolumes = this.exportArrayField("referenceVolumes");
		exportData.referenceVolumeGuids = this.exportArrayField("referenceVolumeGuids");
		exportData.relatedLinks = JSON.stringify(this.__relatedLinks.map(item => item.export()));
		exportData.tags = this.exportArrayField("tags");
		
		return exportData;
	}

	import (data, options) {
		super.import(data, options);
		
		this.__relatedImagesCount = this.relatedContents.filter(item => item.type === "image").length;
		this.__relatedPlacesCount = this.relatedContents.filter(item => item.type === "place").length;
		this.__relatedTextsCount = this.relatedContents.filter(item => item.type === "text").length;

		this.__referenceVolumeLabel = this.referenceVolumes.map(item => item.value).join(",");

		this.parseLinks();
		this.parseReferenceVolumes();
		this.parseTags();
		this.parseType();
		this.parseUsers();

		this.__type_image = this.type === "image";
		this.__type_place = this.type === "place";
		this.__type_text = this.type === "text";
	}
	
	on__referenceVolumesChanged () {
		this.referenceVolumes = this.__referenceVolumes !== "" ? JSON.parse(this.__referenceVolumes) : [];
	}

	on__tagsChanged () {
		this.tags = this.__tags !== "" ? JSON.parse(this.__tags) : [];
	}

	onRelatedLinksChanged () {
		this.parseLinks();
	}

	parseLinks () {
		this.__relatedLinks = this.relatedLinks.map(item => Shark.getInstance("__smart__", item));
		this.__relatedLinks.forEach((item, index) => item.__index = index);
	}

	parseReferenceVolumes () {
		this.__referenceVolumes = JSON.stringify(this.referenceVolumes);
	}

	parseTags () {
		this.__tags = JSON.stringify(this.tags);

		this.__pageTagsLabel = this.tags.filter(item => item?.value?.slice(0, 3).toLowerCase() === "pag").map(item => item.value).join(" | ");
	}

	parseType () {
		const typeMap = {
			image: "Immagine",
			place: "&nbsp;&nbsp;&nbsp;&nbsp;Luogo&nbsp;&nbsp;&nbsp;&nbsp;",
			text: "&nbsp;&nbsp;&nbsp;&nbsp;Testo&nbsp;&nbsp;&nbsp;&nbsp;",
			video: "&nbsp;&nbsp;&nbsp;&nbsp;Video&nbsp;&nbsp;&nbsp;&nbsp;",
		};

		this.__typeLabel = typeMap[this.type];
	}

	parseUsers () {
		const { userList } = Shark.get();

		if (userList) {
			this.__creatorLabel = userList.find(item => item.guid === this.createdByGuid, this)?.__fullName || "";
			this.__updaterLabel = userList.find(item => item.guid === this.updatedByGuid, this)?.__fullName || "";
		}
	}
}

Shark.registerModel("BaseContent", BaseContent);

export default BaseContent;